const API = {
  select3dHomeData:'/wangxiao/scratch/select3dHomeData',
  saveCommunity:'/wangxiao/community/saveCommunity',
  editDetails:'/wangxiao/editDetails',
  login: "/wangxiao/auth/pass/login",
  studentInfo: "/wangxiao/student/info",
  studentInfoC: "/wangxiao/student/infoC",
  studentUpdate: "/wangxiao/student/update",
  studentUpdateC: "/wangxiao/student/updateC",
  uploadFile: "/crm/web/public/getUpAuth",
  newList: "/exam/api/paper/newList",
  listPythonJob: "/wangxiao/listPythonJob",
  listPythonJobC: "/wangxiao/listPythonJobC",
  showList: "/wangxiao/showList",
  showListC: "/wangxiao/showListC",
  publicPic: "/crm/authPass/upload/public/pic",
  scratchList: "/wangxiao/list",
  scratchListC: "/wangxiao/listC",
  coursewareList: "/wangxiao/coursewareList",
  coursewareList3D: "/wangxiao/coursewareList3D",
  coursewareListC: "/wangxiao/coursewareListC",
  rlogin: "/wangxiao/auth/pass/rlogin",
  balance: "/ai/rechargeRecord/balance",
  saveUsage: "/ai/rechargeRecord/saveUsage",
  aiUnifiedOrder: "/ai/rechargeRecord/wangxiao/AiUnifiedOrder",
  tradeQuery: "/ai/rechargeRecord/tradeQuery",
  getRechargeRecord: "/ai/rechargeRecord/list",
  coursewareList2: "/wangxiao/coursewareList2",
  coursewareList2C: "/wangxiao/coursewareList2C",
  teacherCatalogList: "/wangxiao/teacherCatalogList",
  register: "/crm/authPass/saveTheCard",
  delPythonJobC: "/wangxiao/delPythonJobC",
  delWxcHomework: "/wangxiao/delWxcHomework",
  del3dHomework:'wangxiao/del3dHomework',
  homework3dLis: "/wangxiao/homework3dList",
  getInfoListByStudentId: "/wangxiao/scratch/getInfoListByStudentId",
  getCoursewareInfoByCatalogId: "/wangxiao/scratch/getCoursewareInfoByCatalogId",
  select3dHomeData: "/wangxiao/scratch/select3dHomeData",
  saveLearningLog: "/wangxiao/scratch/saveLearningLog",
  communitylist:'/wangxiao/community/list',
  addViewNumber:'/wangxiao/community/addViewNumber',
  communityCancel:'/wangxiao/community/cancel',
  getWebsitePhoneCode:'/crm/official/website/getWangXiaoPhoneCode',
  checkPhoneCode:'/crm/official/website/checkPhoneCode',
  saveWangXiaoStudent:'/crm/official/website/saveWangXiaoStudent',
};

export default API;
